import React from "react";
import { Link } from "react-router-dom";

export default function BannerSection({ background, pageTitle, breadcrumbs = [] }) {
  return (
    <section
      className="page-banner bgs-cover overlay pt-50"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="container">
        <div className="banner-inner">
          <h1 className="page-title">{pageTitle}</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              {breadcrumbs &&
                breadcrumbs.length > 0 &&
                breadcrumbs.map((item) => (
                  <li key={Math.random()} className="breadcrumb-item">
                    <Link to={item.path}>{item.name}</Link>
                  </li>
                ))}
            </ol>
          </nav>
        </div>
      </div>
    </section>
  );
}
